import React, { useContext, useEffect, useState } from "react";
import styles from "./savedproperties.module.scss";
import { useHistory } from "react-router";
import ToastContext from "../../contexts/ToastContext";
import LoadingContext from "../../contexts/LoadingContext";
import { Property } from "../../types/Property";
import { PaginationParamsPersonalizedProperties } from "../../types/propertyType";
import {
  getMortgageListingsApi,
  getSavedProperties,
} from "../../swr/properties";
import PropertyCard from "../../components/PropertyCard";
import Stack from "@mui/system/Stack";
import Pagination from "@mui/material/Pagination";

const Index = () => {
  const { openError } = useContext(ToastContext);
  const { setLoading } = useContext(LoadingContext);
  const [paginationParams, setPaginationParams] = useState({
    PageNumber: 1,
    PageSize: 9,
  });
  const token = localStorage.getItem("token") as string;

  const [properties, setProperties] = useState<Property[] | []>([]);
  const [pageParams, setPageParams] = useState(
    {} as PaginationParamsPersonalizedProperties
  );

  const GetSavedProperties = async () => {
    setLoading(true);
    const { data, error } = await getSavedProperties(paginationParams, token);

    if (data && data.item1) {
      const propertiesArr = data.item1.map((item: any) => item.properties)
      
      setLoading(false);
      setProperties(propertiesArr);
      return;
    }

    if (data && data.item2) {
      setLoading(false);
      setPageParams(data.item2);
      return;
    }

    if (error) {
      openError(
        error.response.data.Message
          ? error.response.data.Message
          : "Unable to fetch saved properties"
      );
      setLoading(false);
      return;
    }

    openError("Unable to fetch saved properties");
    setLoading(false);
    return;
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPaginationParams((prev) => ({ ...prev, PageNumber: newPage }));
  };

  const returnProperties = (mortgagedProperties: Property[]) => {
    return mortgagedProperties.map((prop) => (
      <div className={styles.griditem}>
         <PropertyCard property={prop} key={prop.title} />
      </div>
       
    ));
  };

  useEffect(() => {
    GetSavedProperties();
    if (paginationParams.PageNumber > 0) {
      GetSavedProperties();
    }
  }, []);

  return (
    <div className={styles.overallContainer}>
      {properties && properties.length > 0 ? (
        <>
          <div className={styles.containerI}>{returnProperties(properties)}</div>
          <div className={styles.paginationDiv}>
            {!(
              paginationParams.PageNumber == 1 &&
              properties &&
              properties.length < paginationParams.PageSize
            ) && (
              <Stack
                spacing={2}
                sx={{ marginBottom: "30px", alignItems: "center" }}
              >
                <Pagination
                  count={pageParams && pageParams.totalPages}
                  page={paginationParams.PageNumber}
                  onChange={handlePageChange}
                  size={"large"}
                  variant="outlined"
                  color="standard"
                />
              </Stack>
            )}
          </div>
        </>
      ) : (
        <div className={styles.noListing}>
          <span className={styles.fonts}>No Saved Properties Available</span>
        </div>
      )}
    </div>
  );
};

export default Index;
